import {DataService} from "@/service/data";
import getDateUTCString from "@/utils/date_utils";
import axios from "axios";
import constants from "@/config/constants";
import {base64encode} from "@/utils/common_utils";
import {AuthService} from "@/service/auth";

const state = {};

const getters = {};

const actions = {
    getApiToken() {
        return DataService.getApiToken();
    },

    getCurrentSubscription() {
        return DataService.getCurrentSubscription();
    },

    async getCurrentResidentialSubscription() {
        try {
            const response = await DataService.getCurrentResidentialSubscription();
            return response.data;
        } catch (error) {
            return {};
        }
    },

    async getCurrentDatacenterSubscription() {
        try {
            const response = await DataService.getCurrentDatacenterSubscription();
            return response.data;
        } catch (error) {
            return {};
        }
    },

    async getResidentialCredentials() {
        try {
            const response = await AuthService.get_residential_credentials();
            return response.data;
        } catch (error) {
            return {};
        }
    },

    async getDatacenterCredentials() {
        try {
            const response = await AuthService.get_datacenter_credentials();
            return response.data;
        } catch (error) {
            return {};
        }
    },

    async getAPIRenewStatus() {
        const response = await DataService.getAPIRenewStatus();
        return response.data;
    },

    updateSubscriptionRenewStatus(context, data) {
        return DataService.setAPIRenewStatus(data);
    },

    getUsageGraph() {
        const DATE_OFFSET = 30;
        const currentDate = new Date();
        const prevDate = new Date();
        prevDate.setDate(currentDate.getDate() - DATE_OFFSET);
        return DataService.getUsageGraph(getDateUTCString(prevDate), getDateUTCString(currentDate));
    },

    getResidentialUsageGraph() {
        const DATE_OFFSET = 30;
        const currentDate = new Date();
        const prevDate = new Date();
        prevDate.setDate(currentDate.getDate() - DATE_OFFSET);
        return DataService.getResidentialUsageGraph(getDateUTCString(prevDate), getDateUTCString(currentDate));
    },

    getDatacenterUsageGraph() {
        const DATE_OFFSET = 30;
        const currentDate = new Date();
        const prevDate = new Date();
        prevDate.setDate(currentDate.getDate() - DATE_OFFSET);
        return DataService.getDatacenterUsageGraph(getDateUTCString(prevDate), getDateUTCString(currentDate));
    },

    getRequestResult(context, data) {
        const { apiKey, generatorData } = data;
        const encodedJS = generatorData.js_snippet ? base64encode(generatorData.js_snippet) : "";
        const requestObject = {};
        if (generatorData.response_type === 'extract') {
            requestObject.extract_properties = generatorData.extract_properties;
        }
        if (generatorData.cookies) {
            requestObject.cookies = generatorData.cookies;
        }
        if (generatorData.url) {
            requestObject.url = generatorData.url;
        }
        if (generatorData.proxy_type && generatorData.proxy_type !== "datacenter") {
            requestObject.proxy_type = generatorData.proxy_type;
        }
        if (generatorData.country && generatorData.country !== "ALL") {
            requestObject.proxy_country = generatorData.country;
        }
        if (encodedJS) {
            requestObject.js_snippet = encodedJS;
        }
        if (generatorData.wait_for_selector) {
            requestObject.wait_for_selector = generatorData.wait_for_selector;
        }
        if (!generatorData.browser) {
            requestObject.browser = false;
        }
        if (generatorData.return_page_source) {
            requestObject.return_page_source = true;
        }
        const path = `${constants.API_SERVICE_PATH}/${generatorData.response_type}`;
        return axios({
            method: 'get',
            headers: { 'x-api-key': apiKey },
            url: `https://${constants.API_SERVICE_HOST}${path}`,
            params: requestObject
        });
    }
};

const mutations = {};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
};
